module.exports = __webpack_public_path__ + "img/no-dejes-pasar-esta-oportunidad.95f91109.png";